import { jsx as F, jsxs as H } from "react/jsx-runtime";
import "react";
var i = (l) => /* @__PURE__ */ H("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ F("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ F("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1526 -380)",
      fill: "white"
    }),
    /* @__PURE__ */ F("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ F("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ F("path", {
      d: "M2.60785 6.08691H1.73828V7.2607H2.60785V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M0.86957 6.08691H0V7.2607H0.86957V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M4.34809 6.08691H3.47852V7.2607H4.34809V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M6.08637 6.08691H5.2168V7.2607H6.08637V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M7.8266 6.08691H6.95703V7.2607H7.8266V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M9.56488 6.08691H8.69531V7.2607H9.56488V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M11.3051 6.08691H10.4355V7.2607H11.3051V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M13.0434 6.08691H12.1738V7.2607H13.0434V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M14.7817 6.08691H13.9121V7.2607H14.7817V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M16.5219 6.08691H15.6523V7.2607H16.5219V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M18.2602 6.08691H17.3906V7.2607H18.2602V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M20.0004 6.08691H19.1309V7.2607H20.0004V6.08691Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M2.60785 12.7609H1.73828V13.9129H2.60785V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M0.86957 12.7609H0V13.9129H0.86957V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M4.34809 12.7609H3.47852V13.9129H4.34809V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M6.08637 12.7609H5.2168V13.9129H6.08637V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M7.8266 12.7609H6.95703V13.9129H7.8266V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M9.56488 12.7609H8.69531V13.9129H9.56488V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M11.3051 12.7609H10.4355V13.9129H11.3051V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M13.0434 12.7609H12.1738V13.9129H13.0434V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M14.7817 12.7609H13.9121V13.9129H14.7817V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M16.5219 12.7609H15.6523V13.9129H16.5219V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M18.2602 12.7609H17.3906V13.9129H18.2602V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M20.0004 12.7609H19.1309V13.9129H20.0004V12.7609Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ F("path", {
      d: "M12.4901 7.99996H11.487C11.4953 8.11019 11.5 8.2214 11.5 8.33332C11.5 9.07496 11.3146 9.79378 10.9915 10.3055C10.8918 10.4633 10.7243 10.6862 10.5 10.8366V7.99996H9.5V10.8365C9.27578 10.6861 9.1082 10.4633 9.00852 10.3054C8.68535 9.79375 8.5 9.07492 8.5 8.33324C8.5 8.22136 8.50473 8.11011 8.51301 7.99988H7.50992C7.50348 8.10957 7.5 8.22066 7.5 8.33324C7.5 10.3893 8.59812 11.9999 10 11.9999C11.4019 11.9999 12.5 10.3893 12.5 8.33324C12.5 8.22074 12.4965 8.10964 12.4901 7.99996Z",
      fill: "#D80027"
    })
  ]
});
export {
  i as default
};
